// removed by extract-text-webpack-plugin
module.exports = {"avatar":"_2AQ1p9eGZRgB8d43YPCdPo"};